export const environment = {
    production: false,
    version: 'v0.0.1',
    //apiUrl: 'https://oka-staging.okito.ph/api/v1/', #old api url
    apiUrl: 'https://dev-api.okito.ph/api/v1/',
    //apiUrl_okito_official: 'https://okstaging.okito.ph/',
    apiUrl_okito_official: 'https://dev-api.okito.ph/',
    tokenName: 'okzt',
    userDetailsTokenName: 'oktz',
    otpValidVar: 'otpvalidated',
    apiKey: 'YOUR_API_KEY'
  };
